import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['errors', 'success']

  onSuccess(event) {
    let [data, status, xhr] = event.detail;
    this.successTarget.innerHTML = xhr.response;
    this.successTarget.classList.remove('hidden');
    this.errorsTarget.innerText = "";
    this.element.querySelector('form').reset();
  }

  onError(event) {
    let [data, status, xhr] = event.detail;
    let errors = JSON.parse(xhr.response);
    this.successTarget.innerText = '';
    this.successTarget.classList.add('hidden');

    Object.entries(errors).forEach(error => {
      const [key, value] = error;
      let element = this.element.querySelector(`.invalid-feedback[data-element="${key}"]`)
      if(element)
        element.innerHTML = value.join(', ')
    })
  }
}
